/* eslint-disable */

export enum ScoreType {
  DO_NOT_USE = "DO_NOT_USE",
  /** MODEL - Used for model generated scores */
  MODEL = "MODEL",
  /** RANDOM - Used for randomly generated scores */
  RANDOM = "RANDOM",
  /** SHADOW - Used for scores generated from shadow models */
  SHADOW = "SHADOW",
}

/**
 * Use this enum in the flow config to define the default value strategies for offline model evaluation.
 * More details: https://docs.google.com/document/d/1LNR_FkXDroA96lfp3MqOjiOH5JpOHhcruC-KZWVww7s/edit?usp=sharing
 */
export enum DefaultStrategy {
  DEFAULT_STRATEGY_DO_NOT_USE = "DEFAULT_STRATEGY_DO_NOT_USE",
  /**
   * ITEM_DEFAULT - OFFLINE EVALUATION ONLY,
   * in this strategy, if the model score is missing for the key from the incoming request,
   * Weaver will fetch the feature value of [ITEM_TOKEN]:DEFAULT from the offline feature store as default model value.
   * Assume the delimiter is ":".
   */
  ITEM_DEFAULT = "ITEM_DEFAULT",
  /**
   * GENERAL_DEFAULT - OFFLINE EVALUATION ONLY,
   * in this strategy, if the model score is missing for the key from the incoming request,
   * Weaver will fetch the feature value of GENERAL:DEFAULT from the offline feature store as default model value.
   * Assume the delimiter is ":".
   */
  GENERAL_DEFAULT = "GENERAL_DEFAULT",
}

/** Enum to tell if the model score comes from a default value or a regular evaluated score. */
export enum ScoreSource {
  SCORE_SOURCE_DO_NOT_USE = "SCORE_SOURCE_DO_NOT_USE",
  /** EVALUATED_SCORE - successfully fetched the feature values and evaluated the item. */
  EVALUATED_SCORE = "EVALUATED_SCORE",
  /**
   * ITEM_DEFAULT_SCORE - OFFLINE EVALUATION ONLY, the feature value for the to be evaluated item is missing,
   * we use the user-defined item default value as model score.
   */
  ITEM_DEFAULT_SCORE = "ITEM_DEFAULT_SCORE",
  /**
   * GENERAL_DEFAULT_SCORE - OFFLINE EVALUATION ONLY, the feature value for the to be evaluated item is missing,
   * we use the user-defined static general default value as model score.
   */
  GENERAL_DEFAULT_SCORE = "GENERAL_DEFAULT_SCORE",
}

/**
 * Enum of all Weaver supported recommendation types.
 * Each type should have a recommendation type handler.
 */
export enum RecommendationType {
  DO_NOT_USE_RECOMMENDATION_TYPE = "DO_NOT_USE_RECOMMENDATION_TYPE",
  /**
   * CUSTOMER_AFTERPAY_BUSINESS - Recommendation of afterpay merchants for customers.
   * Details: https://docs.google.com/document/d/1hT_CiRwbj2QfimeqoE9S8OCfirDY1zLtqPE_cfzs57U/edit?usp=sharing
   */
  CUSTOMER_AFTERPAY_BUSINESS = "CUSTOMER_AFTERPAY_BUSINESS",
  /**
   * CUSTOMER_AFTERPAY_CATEGORY - Recommendation of Afterpay category for customers.
   * For example, sports, fashion, pets etc.
   *
   * This is NOT in prod.
   */
  CUSTOMER_AFTERPAY_CATEGORY = "CUSTOMER_AFTERPAY_CATEGORY",
  /**
   * CONTACT - Recommendation of customer contacts.
   * Hashed alias IDs to start.
   */
  CONTACT = "CONTACT",
  /**
   * BOOST_CAROUSEL - Recommendation of boost for customers.
   * For example: Sam's Club, Trader Joe's
   */
  BOOST_CAROUSEL = "BOOST_CAROUSEL",
  /** SHOPHUB_ENTRYPOINT_MERCHANT - Recommendation of Afterpay merchants for shophub entrypoint. */
  SHOPHUB_ENTRYPOINT_MERCHANT = "SHOPHUB_ENTRYPOINT_MERCHANT",
  /** DISCOVER_SECTION_COMPONENT - Recommendation of section components for Discover tab. */
  DISCOVER_SECTION_COMPONENT = "DISCOVER_SECTION_COMPONENT",
  /** BOOKLET_COMPONENT - Recommendation of the booklet component for Money tab. */
  BOOKLET_COMPONENT = "BOOKLET_COMPONENT",
  /** GIFT_CARD - Recommendation of gift cards for customers. */
  GIFT_CARD = "GIFT_CARD",
  /**
   * CONTACTS_FOR_NEW_CUSTOMERS - Recommendation of customer contacts for new customers.
   * Hashed alias IDs to start. Indexed by hashed_alias_token
   */
  CONTACTS_FOR_NEW_CUSTOMERS = "CONTACTS_FOR_NEW_CUSTOMERS",
}

/** Rerank entity type enum. */
export enum RerankEntityType {
  UNSPECIFIED_RERANK_ENTITY = "UNSPECIFIED_RERANK_ENTITY",
  /** APP_FEATURE - App feature entity type, eg. bitcoin or stock as a feature in CashApp. */
  APP_FEATURE = "APP_FEATURE",
  /** CUSTOMER - Cash customer entity type */
  CUSTOMER = "CUSTOMER",
  /** BUSINESS - Business entity type */
  BUSINESS = "BUSINESS",
}

/** The flow key for the RerankEntities endpoint. */
export enum RerankFlowKey {
  UNSPECIFIED_RERANK_FLOW_KEY = "UNSPECIFIED_RERANK_FLOW_KEY",
  /** DISCOVER_SEARCH - Multi-entities search rerank in Discover Tab use case. */
  DISCOVER_SEARCH = "DISCOVER_SEARCH",
}
